import { css, keyframes } from 'styled-components';

export const TOAST_DURATION = 5000;
export const EXIT_DURATION = 400;

const ENTER_DURATION = 500;
const EASING = 'ease';

const openSlot = keyframes`
  from { grid-template-rows: 0fr; }
  to { grid-template-rows: 1fr; }
`;

const slideIn = keyframes`
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
`;

const collapseSlot = keyframes`
  from { height: var(--toast-slot-height); }
  to { height: 0; }
`;

const slideOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(50%); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';

export const slotEnter = css`
  grid-template-rows: 1fr;
  animation: ${openSlot} ${ENTER_DURATION}ms ${EASING};

  ${REDUCED_MOTION} {
    animation: none;
  }
`;

export const slotExit = css`
  position: static;
  height: 0;
  animation: ${collapseSlot} ${EXIT_DURATION}ms ${EASING};

  ${REDUCED_MOTION} {
    animation: none;
  }
`;

export const slideEnter = css`
  animation: ${slideIn} ${ENTER_DURATION}ms ${EASING};

  ${REDUCED_MOTION} {
    animation: ${fadeIn} ${ENTER_DURATION}ms ${EASING};
  }
`;

export const slideExit = css`
  position: absolute;
  top: var(--toast-slot-top);
  right: 0;
  width: var(--toast-slide-width);
  z-index: -1;
  opacity: 0;
  transform: translateY(50%);
  animation: ${slideOut} ${EXIT_DURATION}ms ${EASING};

  ${REDUCED_MOTION} {
    transform: none;
    animation: ${fadeOut} ${EXIT_DURATION}ms ${EASING};
  }
`;
